import { doc, getDoc } from "firebase/firestore";
import { db } from "./firebaseClient";

export async function isCurrentUserAuthorized(uid) {
  const snapshot = await getDoc(doc(db, "authorized_users", uid));
  return snapshot.exists();
}
